/**
 * Created by dmarthak on 29/03/18.
 */

define(function (require, exports, module) {

    'use strict';

    module.exports = function ($window) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.css('overflow', 'hidden');
                element.on('input', function(e) {
                    if (this.value.length > parseInt(attrs.maxlength)) {
                        this.value = this.value.substr(0, parseInt(attrs.maxlength));
                    }
                });
                var update = function(){
                    element.css("height", "auto");
                    var height = element[0].scrollHeight;
                    if(height > 0){
                        element.css("height", height + "px");
                    }
                };
                scope.$watch(attrs.ngModel, function(){
                    update();
                });
                attrs.$set("ngTrim", "false");
            }
        };
    };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/directives/auto-grow.js
// module id = 4
// module chunks = 0